import React from 'react';
import { Loader2 } from 'lucide-react';

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
};

export function LoadingSpinner({ size = 'md', className = '', label = 'Loading' }) {
  return (
    <div role="status" className="inline-flex items-center">
      <Loader2
        data-testid="loading-spinner"
        className={`animate-spin text-muted-foreground ${sizeClasses[size] ?? sizeClasses.md} ${className}`.trim()}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
